/**
 * Navigation Service
 *
 * React Router'ın useNavigate hook'u yalnızca React component'leri içinde
 * çağrılabilir. Zustand store action'ları veya lazy import'larla çalışan
 * hook'lar (wizard, wardrobe, streaming-chat) gibi React dışı bağlamlarda
 * navigate yapmak için bu singleton kullanılır.
 *
 * Kullanım:
 *  1. App.tsx içindeki NavigationInitializer component'i setNavigate'i init eder.
 *  2. Store action'ları veya herhangi bir modül navigateToPricing() çağırabilir.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NavigateFn = (to: any, options?: any) => void;

let _navigate: NavigateFn | null = null;

export const setNavigate = (navigate: NavigateFn) => {
  _navigate = navigate;
};

export const navigateToPricing = (
  cycle: "monthly" | "yearly" | "one-time" = "monthly",
) => {
  _navigate?.(`/pricing?cycle=${cycle}`);
};

export const navigateBack = () => {
  _navigate?.(-1);
};

export const navigateTo = (url: string, state?: unknown) => {
  _navigate?.(url, state === undefined ? undefined : { state });
};
